import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';

export const TopDonatorBadge = () => {
    return (
        <span className="badge rounded-pill text-bg-warning m-1" title="Top Donator">
            <WorkspacePremiumIcon />
        </span>
    )
}